module.exports = __webpack_public_path__ + "media/images/web_suite/feature_icons/icon_quizzes-72e106cd74f7caf19841610f535d02ad.png";